import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule, ShowPasswordDirective } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { TenantClonePopupComponent } from './tenant-clone-popup.component';

@NgModule({
  declarations: [TenantClonePopupComponent],
  imports: [CommonModule, ReactiveFormsModule, CoreModule, ShowPasswordDirective, ThemeSharedModule],
  exports: [TenantClonePopupComponent],
})
export class TenantClonePopupModule {}
